
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton
} from "@/components/ui/sidebar";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { LucideIcon } from "lucide-react";

type MenuItem = {
  title: string;
  path: string;
  icon: LucideIcon;
};

interface SidebarSectionProps {
  title: string;
  items: MenuItem[];
  badgeCount?: {
    itemTitle: string;
    count: number;
  };
}

export const SidebarSection = ({ title, items, badgeCount }: SidebarSectionProps) => {
  const navigate = useNavigate();

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{title}</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                onClick={() => navigate(item.path)}
                tooltip={item.title}
                className="relative pr-6"
              >
                <item.icon className="h-4 w-4 mr-2" />
                <span>{item.title}</span>
                {badgeCount && item.title === badgeCount.itemTitle && badgeCount.count > 0 && (
                  <Badge 
                    className="absolute top-1/2 right-0 -translate-y-1/2 px-1.5 py-0.5 h-[18px] min-w-[18px] flex items-center justify-center bg-red-500 text-[10px] rounded-full"
                  >
                    {badgeCount.count}
                  </Badge>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
